<div class="container">
    <div class="row">
        <div class="col-12" *ngFor="let s of startups">
            <h3>{{s.startup}}: <span>{{s.votes}}</span></h3>
        </div>
    </div>
</div>